import { useEffect, useState } from 'react';

function getIsDarkTheme() {
  if (typeof window === 'undefined') {
    return false;
  }

  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const isSystemTheme = document.documentElement.classList.contains('design-theme--system');

  return prefersDark && isSystemTheme;
}

export function useIsDarkTheme() {
  const [isDarkTheme, setIsDarkTheme] = useState(getIsDarkTheme);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const updateTheme = () => setIsDarkTheme(getIsDarkTheme());

    mediaQuery.addEventListener('change', updateTheme);

    const observer = new MutationObserver(updateTheme);
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    return () => {
      mediaQuery.removeEventListener('change', updateTheme);
      observer.disconnect();
    };
  }, []);

  return isDarkTheme;
}
